@if (posicaoVoltar === 'trilha' && trilhaResolvida(); as trilhaAtual) {
  <div class="admin-page-cabecalho__trilha">
    <cei-breadcrumbs
      [plainItems]="trilhaAtual.plainItems"
      [level2]="trilhaAtual.level2"
      [level1]="trilhaAtual.level1"
      [staticMode]="true"
      tema="claro"
      variante="pills"
    >
      @if (rotaVoltar) {
        <cei-button
          breadcrumb-acoes
          variant="ghost"
          [routerLink]="rotaVoltar"
          marcaSvg="assets/bt_voltar.svg"
          rotuloAcessibilidade="Voltar"
        ></cei-button>
      }
    </cei-breadcrumbs>
  </div>
} @else if (rotaVoltar) {
  <div class="admin-page-cabecalho__acoes">
    <cei-button
      variant="ghost"
      [routerLink]="rotaVoltar"
      marcaSvg="assets/bt_voltar.svg"
      rotuloAcessibilidade="Voltar"
    ></cei-button>
  </div>
}

<h2 class="admin-page-cabecalho__titulo">{{ titulo }}</h2>
